(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2492],{

/***/ 41127:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(61962);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/logo-blog.e7269108.jpg","height":80,"width":44,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAQDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAeEAABBAEFAAAAAAAAAAAAAAADAAECBBESI1KBof/EABUBAQEAAAAAAAAAAAAAAAAAAAMF/8QAGREAAwADAAAAAAAAAAAAAAAAAAECERIh/9oADAMBAAIRAxEAPwCkCvXqszRkAx9ZZTbDPttx8z2iIjyylrD65P/Z"});

/***/ }),

/***/ 61962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/assets/images/user1.png
/* harmony default export */ var user1 = ({"src":"/_next/static/media/user1.38355e51.png","height":225,"width":225,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAElBMVEXl5+jU19mrsbTg4uO2vL7Fyswe2uKVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVQImU3GsREAMAjDQJDt/VfOQVJEjb7qq/sdrgJZyNY+dkYGsEq96QAJHgBcYVTdjQAAAABJRU5ErkJggg=="});
// EXTERNAL MODULE: ./src/layout/layout.tsx + 26 modules
var layout = __webpack_require__(26419);
// EXTERNAL MODULE: ./src/store/slices/blog.ts
var blog = __webpack_require__(63520);
// EXTERNAL MODULE: ./src/styles/blog_details.module.scss
var blog_details_module = __webpack_require__(45873);
var blog_details_module_default = /*#__PURE__*/__webpack_require__.n(blog_details_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
;// CONCATENATED MODULE: ./src/pages/blog/[slug].tsx









var Blog = function() {
    var blogState = (0,es/* useSelector */.v9)(blog/* selectBlog */.N8);
    var ref = (0,react.useState)(false), windowAvailable = ref[0], setWindowAvailable = ref[1];
    (0,react.useEffect)(function() {
        return setWindowAvailable(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (blog_details_module_default()).blog_bg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: "Blog"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (blog_details_module_default()).blog_section,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-lg-8 col-md-7",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-lg-12 col-md-12 mb-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (blog_details_module_default()).blog_main,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (blog_details_module_default()).blog_main_image_d,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: blogState.detail.data.image,
                                                        alt: blogState.detail.data.title,
                                                        className: "img-fluid",
                                                        layout: "fill",
                                                        priority: true
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex icon-color",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-flex align-items-center me-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "mt-1 mb-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bi bi-calendar-check"
                                                        }),
                                                        " ",
                                                        blogState.detail.data.date
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-flex align-items-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "mt-1 mb-0",
                                                    children: [
                                                        "| ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bi bi-person ms-2"
                                                        }),
                                                        " ",
                                                        blogState.detail.data.user
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (blog_details_module_default()).blog_heading,
                                        children: blogState.detail.data.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: blogState.detail.data.content
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (blog_details_module_default()).blog_new_d,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex justify-content-between mt-2 mb-5 border-top border-bottom",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-flex align-items-center me-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        className: "mt-0 mb-0",
                                                        children: "Share"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-flex justify-content-end align-items-center me-2",
                                                    children: windowAvailable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (blog_details_module_default()).social_links,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "twitter",
                                                                target: "_blank",
                                                                href: "https://twitter.com/intent/tweet?url=".concat(encodeURIComponent(location.href), "&text=").concat(blogState.detail.data.title),
                                                                rel: "noreferrer",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "bi bi-twitter"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "facebook",
                                                                target: "_blank",
                                                                href: "https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(location.href), "&t=").concat(blogState.detail.data.title),
                                                                rel: "noreferrer",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "bi bi-facebook"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "linkedin",
                                                                target: "_blank",
                                                                href: "https://wa.me/?text=".concat(encodeURIComponent(location.href)),
                                                                rel: "noreferrer",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "bi bi-whatsapp"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "py-4 d-none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-12 col-lg-12 m-auto",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "bg-white rounded-3 shadow-sm p-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        className: "mb-4",
                                                        children: "7 Comments"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "py-3",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "d-flex comment",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                                    className: (blog_details_module_default()).rounded_circle,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: user1,
                                                                        alt: ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex-grow-1 ms-3",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    href: "#",
                                                                                    className: "fw-bold link-dark me-1",
                                                                                    children: "Studio KonKon"
                                                                                }),
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "text-muted text-nowrap",
                                                                                    children: "2 days ago"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "mb-2",
                                                                            children: "Lorem ipsum dolor sit amet, ut qui commodo sensibus, id utinam inermis constituto vim. In nam dolorum interesset, per fierent ponderum ea. Eos aperiri feugiat democritum ne."
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mt-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "d-flex",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex-grow-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "form-floating mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                                                className: "form-control w-100 min-h-100",
                                                                                placeholder: "Leave a comment here",
                                                                                id: "my-comment"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "my-comment",
                                                                                children: "Leave a comment here"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "hstack justify-content-end gap-2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                role: "button",
                                                                                "aria-label": "cancel",
                                                                                className: "btn btn-sm btn-link cancel link-secondary text-uppercase",
                                                                                children: "cancel"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                role: "button",
                                                                                "aria-label": "comment",
                                                                                className: "btn comment-btn btn-primary text-uppercase",
                                                                                children: "comment"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-lg-4 col-md-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (blog_details_module_default()).blog_sidebar,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: "About us"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (blog_details_module_default()).logo_blog,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "img-fluid",
                                                    src: __webpack_require__(97608),
                                                    alt: "alt"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-center",
                                                children: blogState.detail.about
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (blog_details_module_default()).social_links1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#",
                                                        className: "twitter",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bx bxl-twitter"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#",
                                                        className: "facebook",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bx bxl-facebook"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#",
                                                        className: "google-plus",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bx bxl-youtube"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#",
                                                        className: "instagram",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bx bxl-instagram"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#",
                                                        className: "linkedin",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bx bxl-whatsapp"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (blog_details_module_default()).category,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Categories"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/blog",
                                                            children: "View All"
                                                        })
                                                    }),
                                                    blogState.detail.categories.map(function(category) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/blog/category/".concat(category.slug),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    children: [
                                                                        category.name,
                                                                        " (",
                                                                        category.post_count,
                                                                        ")"
                                                                    ]
                                                                })
                                                            })
                                                        }, category.name);
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (blog_details_module_default()).recent_post,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                children: "Recent Blogs"
                                            }),
                                            blogState.detail.recent_posts.map(function(post) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/blog/".concat(post.slug),
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "row g-0 pointer",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-lg-4 col-md-6",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "img-fluid",
                                                                    src: post.image,
                                                                    alt: "Post image",
                                                                    width: 110,
                                                                    height: 50
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "col-lg-8 col-md-6",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (blog_details_module_default()).h4,
                                                                        children: [
                                                                            post.title.substring(0, 55),
                                                                            "..."
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: post.date
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }, post.slug);
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
Blog.getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (Blog);


/***/ }),

/***/ 45873:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blog_bg":"blog_details_blog_bg__U3qNP","blog_heading":"blog_details_blog_heading__2dDS5","blog_section":"blog_details_blog_section__4wCDf","blog_main":"blog_details_blog_main__4cKBs","blog_date":"blog_details_blog_date__K3yWB","comment_heading":"blog_details_comment_heading__FM0XS","comment":"blog_details_comment___uX8V","send_btn":"blog_details_send_btn__0V_LG","blog_sidebar":"blog_details_blog_sidebar__D2ngB","logo_text":"blog_details_logo_text__bXhzj","social_links1":"blog_details_social_links1__qym99","category":"blog_details_category__SroZc","recent_post":"blog_details_recent_post__HvZjk","h4":"blog_details_h4__kTS2S","blog_inside_image":"blog_details_blog_inside_image__PZCf1","logo_blog":"blog_details_logo_blog__EnsLm","text_left":"blog_details_text_left__tUnpz","rounded_circle":"blog_details_rounded_circle__QvSAw","blog_new_d":"blog_details_blog_new_d___S2r3","social_links":"blog_details_social_links__TRcuA","icon-color":"blog_details_icon-color__YPVb4","blog_main_image_d":"blog_details_blog_main_image_d__blhZ6","blog-desc-link":"blog_details_blog-desc-link__kNeqG"};

/***/ }),

/***/ 5607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(47150);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Collapse.js + 1 modules
var Collapse = __webpack_require__(16518);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionContext.js

function isAccordionItemSelected(activeEventKey, eventKey) {
  return Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : activeEventKey === eventKey;
}
const context = /*#__PURE__*/react.createContext({});
context.displayName = 'AccordionContext';
/* harmony default export */ var AccordionContext = (context);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionCollapse.js








/**
 * This component accepts all of [`Collapse`'s props](/utilities/transitions/#collapse-props).
 */
const AccordionCollapse = /*#__PURE__*/react.forwardRef(({
  as: Component = 'div',
  bsPrefix,
  className,
  children,
  eventKey,
  ...props
}, ref) => {
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-collapse');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse/* default */.Z, {
    ref: ref,
    in: isAccordionItemSelected(activeEventKey, eventKey),
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      children: react.Children.only(children)
    })
  });
});
AccordionCollapse.displayName = 'AccordionCollapse';
/* harmony default export */ var esm_AccordionCollapse = (AccordionCollapse);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItemContext.js

const AccordionItemContext_context = /*#__PURE__*/react.createContext({
  eventKey: ''
});
AccordionItemContext_context.displayName = 'AccordionItemContext';
/* harmony default export */ var AccordionItemContext = (AccordionItemContext_context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionBody.js







const AccordionBody = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-body');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionCollapse, {
    eventKey: eventKey,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionBody.displayName = 'AccordionBody';
/* harmony default export */ var esm_AccordionBody = (AccordionBody);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionButton.js







function useAccordionButton(eventKey, onClick) {
  const {
    activeEventKey,
    onSelect,
    alwaysOpen
  } = (0,react.useContext)(AccordionContext);
  return e => {
    /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */
    let eventKeyPassed = eventKey === activeEventKey ? null : eventKey;

    if (alwaysOpen) {
      if (Array.isArray(activeEventKey)) {
        if (activeEventKey.includes(eventKey)) {
          eventKeyPassed = activeEventKey.filter(k => k !== eventKey);
        } else {
          eventKeyPassed = [...activeEventKey, eventKey];
        }
      } else {
        // activeEventKey is undefined.
        eventKeyPassed = [eventKey];
      }
    }

    onSelect == null ? void 0 : onSelect(eventKeyPassed, e);
    onClick == null ? void 0 : onClick(e);
  };
}
const AccordionButton = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'button',
  bsPrefix,
  className,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-button');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  const accordionOnClick = useAccordionButton(eventKey, onClick);
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);

  if (Component === 'button') {
    props.type = 'button';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    onClick: accordionOnClick,
    ...props,
    "aria-expanded": eventKey === activeEventKey,
    className: classnames_default()(className, bsPrefix, !isAccordionItemSelected(activeEventKey, eventKey) && 'collapsed')
  });
});
AccordionButton.displayName = 'AccordionButton';
/* harmony default export */ var esm_AccordionButton = (AccordionButton);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionHeader.js





const AccordionHeader = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'h2',
  bsPrefix,
  className,
  children,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionButton, {
      onClick: onClick,
      children: children
    })
  });
});
AccordionHeader.displayName = 'AccordionHeader';
/* harmony default export */ var esm_AccordionHeader = (AccordionHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItem.js






const AccordionItem = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  eventKey,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-item');
  const contextValue = (0,react.useMemo)(() => ({
    eventKey
  }), [eventKey]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionItemContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionItem.displayName = 'AccordionItem';
/* harmony default export */ var esm_AccordionItem = (AccordionItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Accordion.js












const Accordion = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    activeKey,
    bsPrefix,
    className,
    onSelect,
    flush,
    alwaysOpen,
    ...controlledProps
  } = (0,esm/* useUncontrolled */.Ch)(props, {
    activeKey: 'onSelect'
  });
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion');
  const contextValue = (0,react.useMemo)(() => ({
    activeEventKey: activeKey,
    onSelect,
    alwaysOpen
  }), [activeKey, onSelect, alwaysOpen]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...controlledProps,
      className: classnames_default()(className, prefix, flush && `${prefix}-flush`)
    })
  });
});
Accordion.displayName = 'Accordion';
/* harmony default export */ var esm_Accordion = (Object.assign(Accordion, {
  Button: esm_AccordionButton,
  Collapse: esm_AccordionCollapse,
  Item: esm_AccordionItem,
  Header: esm_AccordionHeader,
  Body: esm_AccordionBody
}));

/***/ }),

/***/ 27977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const defaultProps = {
  bg: 'primary',
  pill: false
};
const Badge = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  bg,
  pill,
  text,
  className,
  as: Component = 'span',
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'badge');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
  });
});
Badge.displayName = 'Badge';
Badge.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Badge);

/***/ }),

/***/ 55111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Marquee */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Animation = function (_a) {
    var axis = _a.axis, reverse = _a.reverse, offset = _a.offset, id = _a.id;
    return (jsx("style", { children: "\n        @keyframes m" + id + "slide" + offset + " {\n          from {\n            transform: translate" + (axis || "X") + "(" + offset * 100 + "%);\n          }\n          to {\n            transform: translate" + (axis || "X") + "(" + ((reverse ? -100 : 100) + 100 * offset) + "%);\n          }\n        }\n\n        @-webkit-keyframes m" + id + "slide" + offset + " {\n          from {\n            transform: translate" + (axis || "X") + "(" + offset * 100 + "%);\n          }\n          to {\n            transform: translate" + (axis || "X") + "(" + ((reverse ? -100 : 100) + 100 * offset) + "%);\n          }\n        }\n\n        @media (prefers-reduced-motion) {\n            animation: none;\n            -webkit-animation: none;\n        }\n      " }, void 0));
};

var marqueeCounter = 0;
var Marquee = function (_a) {
    var axis = _a.axis, reverse = _a.reverse, align = _a.align, background = _a.background, duration = _a.duration, height = _a.height, pauseOnHover = _a.pauseOnHover, width = _a.width, className = _a.className, children = _a.children;
    var _b = useState("running"), animate = _b[0], setAnimate = _b[1];
    var _c = useState(0), id = _c[0], setId = _c[1];
    useEffect(function () {
        setId(marqueeCounter);
        marqueeCounter++;
    }, []);
    var offsetValues = [-1, 0, 1];
    return (jsx("div", __assign({ className: className, onMouseEnter: function () { return pauseOnHover && setAnimate("paused"); }, onMouseLeave: function () { return pauseOnHover && setAnimate("running"); }, style: {
            display: "flex",
            overflow: "hidden",
            alignItems: "center",
            position: "relative",
            backgroundColor: background !== null && background !== void 0 ? background : "transparent",
            height: height !== null && height !== void 0 ? height : "5rem",
            width: width !== null && width !== void 0 ? width : "100%",
        } }, { children: offsetValues.map(function (offset) { return (jsxs("span", __assign({ style: {
                display: "inline-block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                position: "absolute",
                animation: "m" + id + "slide" + offset + " " + (duration !== null && duration !== void 0 ? duration : 5000) + "ms linear infinite",
                animationPlayState: animate !== null && animate !== void 0 ? animate : "running",
                minWidth: "100%",
            } }, { children: [jsx(Animation, { reverse: reverse, offset: offset, axis: axis, id: id }, void 0),
                jsx("div", __assign({ style: {
                        width: "100%",
                        height: "100%",
                        whiteSpace: "nowrap",
                        display: "flex",
                        overflow: "hidden",
                        justifyContent: "space-around",
                        flexDirection: axis === "X"
                            ? reverse
                                ? "row-reverse"
                                : "row"
                            : axis === "Y"
                                ? reverse
                                    ? "column-reverse"
                                    : "column"
                                : "row",
                        alignItems: align === "center" ? "center" : "flex-" + align,
                    } }, { children: children }), void 0)] }), offset)); }) }), void 0));
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Marquee)));

//# sourceMappingURL=index.es.js.map


/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,959,6067,3564,1825,9774,2888,179], function() { return __webpack_exec__(41127); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);